export const ieo = {
  zzjx: 'В процессе',
  rgjl: 'История подписок',
  yjjs: 'Завершено',
  sf: 'Первичное предложение',
  mjze: 'Общая собранная сумма',
  ckjz: 'Прогресс сбора средств',
  tips_1: 'Платформа Biking Startup официально запущена! Вместе с Biking откройте секреты заработка!',
  tips_2: 'Скоро появятся новые качественные проекты. Следите за обновлениями!',
  jyjjks: 'Торги скоро начнутся',
  ksjy: 'Начать торги',
  qjy: 'Перейти к торгам',
  xmmc: 'Название проекта',
  xmfjs: 'Описание проекта',
  syxm: 'Все проекты',
  banner_1: 'Новая платформа первичного предложения блокчейн-проектов',
  banner_2: 'Вместе с Biking ищем «тёмных лошадок» блокчейна и открываем путь к финансовой свободе',
  ywc: 'Завершено',
  rgsj: 'Время подписки:',
  zcz: 'Участники',
  dqjd: 'Текущий прогресс',
  yck: 'Собрано',
  sddb: 'Получено токенов',
  dff: 'Ожидают выдачи',
  zwxm: 'Нет проектов',
  xq: 'Подробнее',
  wksyr: 'Пре-разогрев не начат',
  yrz: 'Идёт разогрев',
  jxz: 'В процессе',
  yjs: 'Завершено',
  ts: 'Внимание',
  dbwfjy: 'Данный токен временно недоступен для торговли',
  ckqtdb: 'Пожалуйста, выберите другие токены',
  xm: 'Проект',
  ksrg: 'Начать подписку',
  yrg: 'Подписано',
  xmjs: 'Описание проекта',
  csjg: 'Начальная цена',
  dbzl: 'Общее количество токенов: {amount} шт.',
  cssz: 'Начальная капитализация: {fdv} USD',
  xmcytj: 'Условия участия в проекте',
  cjygzh: 'Создайте аккаунт Biking',
  yyzh: 'Уже есть аккаунт — войдите',
  dlzhjkcy: 'Войдите в аккаунт, чтобы участвовать в подписке',
  dljkrg: 'Войдите, чтобы подписаться',
  xhzc: 'Спот-активы',
  zcdy: 'Спот-активы ≥ 10 USDT',
  rggz: 'Правила подписки',
  rgcg: 'Подписка успешна',
  cgrgxm: 'Поздравляем! Вы успешно подписали проект!',
  fhsy: 'Вернуться на главную',
  cyrghd: 'Участвовать в подписке Biking Startup',
  rgje: 'Сумма подписки',
  xhzcgz: 'Оценка спот-активов',
  rgsm: 'Пояснение к подписке:',
  rgsm1: '1. Сумма подписки на пользователя: от {amount1} USDT до {amount2} USDT;',
  rgsm2: "2. Распределение токенов пропорционально внесённым средствам. Если сумма подписки превышает фактически распределённые токены, оставшиеся USDT будут возвращены на ваш счёт после завершения подписки.",
  qd: 'Подтвердить',
  dyr: 'Ожидает разогрева',
  rgdjs: 'Обратный отсчёт до подписки',
  yrdjs: "Обратный отсчёт до разогрева",
  jykqdjs: 'Обратный отсчёт до начала торгов',
  qrg: 'Перейти к подписке',
  rgjebdy: 'Минимальная сумма подписки: {amount} USDT',
  rgjebgy: 'Максимальная сумма подписки: {amount} USDT',
  rgjeccdqjc: 'Сумма подписки превышает текущий баланс',
  fxts1: "1. Ранние проекты находятся на начальной стадии развития; существуют значительные риски, связанные с операционной деятельностью, базовыми технологиями, регуляторной средой и т.д.",
  fxts2: "2. Для понимания токена и оценки его внутренних рисков требуются продвинутые технические и финансовые знания.",
  fxts3: "3. Цена приобретённого вами токена может сильно колебаться под влиянием технологических, регуляторных, рыночных и других факторов; возможно как существенное снижение, так и повышение.",
  fxts4: "4. Из-за особенностей базовой технологии токена или платформы BIKING вы можете не иметь возможности вывести приобретённые токены полностью или частично.",
  sfpt: "Платформа первичного предложения блокчейн-проектов",
  xmhzsq: "Заявка на сотрудничество по проекту",
  hdlx: "Тип мероприятия",
  yryq: "Один человек — один билет",
  yrdq: "Один человек — несколько билетов",
  hdjg: "Цена участия",
  hdsl: "Количество по мероприятию",
  zqs: "Всего билетов",
  rgqs: "Количество билетов по подписке",
  rgsl: "Количество подписки",
  mqsl: "Количество на билет",
  mrzgqs: "Максимум билетов на человека",
  qian: "билет(ов)",
  lian: "Сеть",
  hdrgsm: "Пояснение к подписке: подписка происходит после выигрыша билета. Победители выбираются случайным образом из всех выигравших билеты. В случае неудачной подписки USDT за неудачную подписку возвращаются одновременно с раздачей токенов.",
  jqqd: "Следите за объявлением результатов розыгрыша билетов",
  dbffkjy: "Токен можно будет торговать после его выдачи",
  dzjgb: "Ожидание объявления выигрышных билетов",
  dzq: "Ожидание билета",
  ffzt: "Статус выдачи",
  dbff: "Выдача токенов по выигрышным билетам",
  yff: "Выдано",
  wzq: "Не выиграл билет",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/ru.js